import React, { FC } from 'react';
import { Chip as BaseChip, ChipProps } from '@mui/material';

import { Typography } from '../Typography';


interface ChipCustom extends Omit<ChipProps, 'variant'> {
    iconColor?: string;
    variant?: 'base' | 'primary' | 'secondary';
    active?: boolean;
}

export const Chip: FC<ChipCustom> = ({
    label,
    variant = 'base',
    active,
    sx,
    ...props
}) => (
    <BaseChip
        label={<Typography variant='mediumCaption1' color='grayscale.shade95'>{label}</Typography>}
        variant='filled'
        {...props}
        sx={[({ palette: { grayscale } }) => ({
            px: 3,
            py: 1.5,
            background: variant === 'base' ? grayscale.shade0 : variant === 'secondary' && active ? grayscale.shade95 : grayscale.shade10,
            border: 1,
            borderColor: active ? grayscale.shade95 : variant === 'base' ? grayscale.shade0 : grayscale.shade10,
            '&.hover': {
                background: grayscale.shade20,
            },
        }),
        ...Array.isArray(sx) ? sx : [sx],
        ]}
    />
);
